import React from "react";

function Error() {
  return (
    <div>
      <h1>Uh-OOoo Somthing WEent Wrong!!!</h1>
    </div>
  );
}

export default Error;
